// Поддерживаемые форматы медиа (контекст media).
export enum MediaKind {
  Image = 'image',
  Video = 'video',
}

export interface MediaFormat {
  ext: string;
  mime: string;
  kind: MediaKind;
  /** Браузер показывает файл как есть. */
  browserDisplayable: boolean;
  /** Нужна JPEG-копия — спутник оригинала для просмотра и публикации (MED-UC-6). */
  needsRendition: boolean;
}

export const MEDIA_FORMATS: readonly MediaFormat[] = [
  { ext: 'jpg', mime: 'image/jpeg', kind: MediaKind.Image, browserDisplayable: true, needsRendition: false },
  { ext: 'jpeg', mime: 'image/jpeg', kind: MediaKind.Image, browserDisplayable: true, needsRendition: false },
  { ext: 'png', mime: 'image/png', kind: MediaKind.Image, browserDisplayable: true, needsRendition: false },
  // ADR-020: соцсети WebP как фото принимают не везде — у него JPEG-копия.
  { ext: 'webp', mime: 'image/webp', kind: MediaKind.Image, browserDisplayable: true, needsRendition: true },
  { ext: 'gif', mime: 'image/gif', kind: MediaKind.Image, browserDisplayable: true, needsRendition: false },
  { ext: 'heic', mime: 'image/heic', kind: MediaKind.Image, browserDisplayable: false, needsRendition: true },
  { ext: 'heif', mime: 'image/heif', kind: MediaKind.Image, browserDisplayable: false, needsRendition: true },
  { ext: 'tif', mime: 'image/tiff', kind: MediaKind.Image, browserDisplayable: false, needsRendition: true },
  { ext: 'tiff', mime: 'image/tiff', kind: MediaKind.Image, browserDisplayable: false, needsRendition: true },
  { ext: 'avif', mime: 'image/avif', kind: MediaKind.Image, browserDisplayable: true, needsRendition: true },
  { ext: 'dng', mime: 'image/x-adobe-dng', kind: MediaKind.Image, browserDisplayable: false, needsRendition: true },
  // Chrome и Firefox по умолчанию JPEG XL не показывают: вместо оригинала — превью и копия.
  { ext: 'jxl', mime: 'image/jxl', kind: MediaKind.Image, browserDisplayable: false, needsRendition: true },
  { ext: 'mp4', mime: 'video/mp4', kind: MediaKind.Video, browserDisplayable: true, needsRendition: false },
  { ext: 'mov', mime: 'video/quicktime', kind: MediaKind.Video, browserDisplayable: false, needsRendition: false },
  { ext: 'm4v', mime: 'video/x-m4v', kind: MediaKind.Video, browserDisplayable: true, needsRendition: false },
  { ext: 'webm', mime: 'video/webm', kind: MediaKind.Video, browserDisplayable: true, needsRendition: false },
  { ext: '3gp', mime: 'video/3gpp', kind: MediaKind.Video, browserDisplayable: false, needsRendition: false },
];

export function fileExtension(fileName: string): string {
  const dot = fileName.lastIndexOf('.');
  return dot >= 0 ? fileName.slice(dot + 1).toLowerCase() : '';
}

export function formatByFileName(fileName: string): MediaFormat | null {
  const ext = fileExtension(fileName);
  return MEDIA_FORMATS.find((format) => format.ext === ext) ?? null;
}

export const ACCEPTED_UPLOAD_EXTENSIONS: readonly string[] = MEDIA_FORMATS.map((format) => `.${format.ext}`);
